/**
 * Return Supabase Storage public URLs unchanged.
 * The /render/image/ transformation endpoint is NOT available on this project,
 * so we simply pass through the original /object/public/ URL.
 *
 * Non-Supabase URLs are also returned unchanged.
 */
export function optimizedImageUrl(
  url: string | null | undefined,
  _width: number = 280,
  _quality: number = 65
): string {
  if (!url) return "";
  return url;
}
